<template>
  <div class="topdiv">
    <div class="bg-red">
      <div class="wd1200">
        <router-link class="dinline-block vtop" to="/enroll/index">
          <img src="../../assets/images/sindex_01_01.png" alt="">
        </router-link>
      </div>
    </div>
    <div class="enav nav bgw header fs14 prelative">
      <div class="wd1200 fs0">
        <template v-for="(item,index) in $params.enrollColumn">
          <router-link v-if="item.type==1" :to="{path:item.to,query:{pid:index,category_id:item.params.category_id}}" class="am fs18 ml30 tc-red">{{item.name}}</router-link>
          <div v-else-if="item.type==2" class="hav am fs18 dinline-block tcenter cpointer tc-red prelative">
            {{item.name}}
            <div class="snav tleft bgw prelative fs16 bg-red">
              <template v-for="(child,index_) in item.children">
                <router-link v-if="child.to=='/enroll/article/list'" :to="{path:child.to,query:{pid:index,id:index_,category_id:child.params.category_id}}" :key="index_+index"
                             class="dblock tcenter twhite">
                  {{child.name}}
                </router-link>
                <router-link v-else :to="{path:child.to,query:{pid:index,id:index_,article_id:child.params.article_id}}" :key="index_+index"
                             class="dblock tcenter twhite">
                  {{child.name}}
                </router-link>
              </template>
            </div>
          </div>
          <a v-else-if="item.type==3" :href="item.to" class="am fs18 ml30 tc-red" target="_blank">{{item.name}}</a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Top"
    }
</script>

<style scoped>
  .nav{height: 52px;}
  .nav .am{position: relative;margin-right: 35px;padding: 0 20px;line-height: 52px;}
  .nav .am:last-child{margin-right: 0;}
  .nav .hav:hover::after{opacity: 1;}
  .nav .hav:hover .snav{height: auto;transform: rotate3d(0,0,0,0);z-index: 1000;}
  .nav .hav::after,.nav .snav{transition: all .3s ease-in-out;}
  .nav .hav::after{content: '';opacity: 0;position: absolute;left: 50%;margin-left: -8px;bottom: 0;border: 8px solid transparent;border-bottom: 8px solid #fff;}
  .nav .snav{overflow: hidden;padding: 35px;position: absolute;left: -150px;z-index: 999;width: 975px;height: 0;line-height: 1.4;transform: rotate3d(1,0,0,90deg);
    background: #fff;transform-origin: center top;cursor: default;}
  .nav .kh{width: 180px;line-height: 2.2;}
  .nav .alist{margin-left: 80px;padding: 25px 0 0 0;width: 450px;}
  .nav .alist a:hover{font-weight: bold;}
  .nav .alist a{width: 115px;font-size: 17px;}

  .enav .am:not(.hav):hover{font-weight: bold;}
  .enav .hav:hover{background: #94070a;color: #fff;}
  .enav .hav:hover::before{background: #94070a;}
  .enav .am:first-child{padding-left: 5px;}
  .enav .am:last-child{padding-right: 0;}
  .enav .am:last-child::before{width: 0;}
  .enav .am{margin: 0 0 0 -1px;padding: 0 33px;display: inline-block}
  .enav .hav::after{border-width: 0;}
  .enav .am::before{content: '';position: absolute;right: 0;top: 16px;bottom: 16px;width: 1px;background: #9c9c9d;}
  .enav .snav{left: 0;padding: 0;right: 0;width: auto;height: 50px;background: #94070a;border-bottom-left-radius: 4px;border-bottom-right-radius: 4px;}
  .enav .snav a{padding: 0;line-height: 45px;}
  .enav .snav a:hover{background: #b02e31;}

</style>



// WEBPACK FOOTER //
// src/components/enroll/Top.vue